import * as Yup from 'yup';

export const roleSchema = Yup.object().shape({

    roleId: Yup.number().min(1,"Please enter valid number").required("Please enter a role id"),
    name: Yup.string().required("Please enter a name"),
    permissionIds: Yup.array().min(1,"Please select at least one permission")
    
})
